import { CACHED_NOTICE_LIST } from "@/core/constant";
import Storage from "@/core/services/storage";
let lockr = new Storage("cpms_");
export type Notice = {
  noticeList: Array<string>;
};
export default {
  namespaced: true,
  state: {
    noticeList: lockr?.get(CACHED_NOTICE_LIST) || [],
  },
  mutations: {
    SET_NOTICE_LIST: function (state, list) {
      state.noticeList = list;
      lockr.set(CACHED_NOTICE_LIST, list);
    },
  },
  actions: {},
  getters: {},
};
